import { useMemo } from 'react'
import { useAccountBalances } from 'store/account/hooks'
import { useCurrencies, useMarketIndexes } from 'store/market/hooks'
import { calcTotalSpotConversionMarginValue } from 'utils/valuation/calcTotalSpotConversionMarginValue'
import { BigNumber } from 'ethers'

// The total value of USDT after converting the balance of spot holdings into margin.
// sum(balance * price * conversionRatio)
export function useTotalSpotConversionMarginValue(): BigNumber {
  const balances = useAccountBalances()
  const currencies = useCurrencies()
  const indexes = useMarketIndexes()

  return useMemo(() => {
    return calcTotalSpotConversionMarginValue(balances, currencies, indexes)
  }, [balances, currencies, indexes])
}
